import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import moment from 'moment';
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class InvoiceSearch extends BaseModel {
  customer_uuid = null;
  invoice_no = null;
  type = null;
  status = [];
  shipping_status = null;
  sale_search = null;
  overdue = null;
  overdue_notification_not_sent = null;
  unpaid_notification_not_sent = null;
  min_amount = null;
  max_amount = null;
  shipping_tracking_code = null;
  export_id_min = null;
  export_id_max = null;
  approved = null;
  lot_no = null;
  is_not_exported = null;
  is_previously_exported = null;
  dateRange = {startDate: null, endDate: null};
  is_payments_not_exported = null;
  is_payments_previously_exported = null;
  salesDateRange = {startDate: null, endDate: null};
  paymentsDateRange = {startDate: null, endDate: null};
  identity_verification = null;
  kyc_status_verification = null;
  collector = null;
  buyer_group_account = null;
  partially_paid = null;
  branch_uuids = [];
  first_name = null;
  last_name = null;
  company_name = null;
  client_tier = null
  exclude_from_auto_payments = null;
  auto_payment_status = null;
  tags = null;
  payment_terms = null;
  source_of_sale = [];
  miscellaneous_item_title = null;

  rules = {};

  attributeLabels = {
    type: i18n.t('Type'),
    customer_uuid: i18n.t('Customer'),
    invoice_no: i18n.t('Invoice'),
    sale_search: i18n.t('Sale'),
    status: i18n.t('Status'),
    shipping_status: i18n.t('Shipping Status'),
    overdue: i18n.t('Overdue'),
    overdue_notification_not_sent: i18n.t('Overdue Email Not Sent'),
    unpaid_notification_not_sent: i18n.t('Unpaid Email Not Sent'),
    min_amount: i18n.t('Min Amount'),
    max_amount: i18n.t('Max Amount'),
    shipping_tracking_code: i18n.t('Tracking Code'),
    export_id_min: i18n.t('From Export ID'),
    export_id_max: i18n.t('To Export ID'),
    approved: i18n.t('Approved'),
    lot_no: i18n.t('Lot Number'),
    is_not_exported: i18n.t('Not Exported'),
    is_previously_exported: i18n.t('Previously exported'),
    is_payments_not_exported: i18n.t("Payments not exported"),
    is_payments_previously_exported: i18n.t("Payments previously exported"),
    identity_verification: i18n.t('Identity Verification'),
    kyc_status_verification: i18n.t('Account/KYC Verification'),
    collector: i18n.t('Collector'),
    buyer_group_account: i18n.t('Buyer Group Account'),
    partially_paid: i18n.t('Partially Paid'),
    branch_uuids: i18n.t('Branch'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    company_name: i18n.t('Company Name'),
    exclude_from_auto_payments: i18n.t('Exclude from Auto-Payments'),
    auto_payment_status: i18n.t('Status of Auto-Payments'),
    tags: i18n.t('Tags'),
    payment_terms: i18n.t('Payment Terms'),
    miscellaneous_item_title: i18n.t('Miscellaneous Charge'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.customer;

    if (!this.overdue) {
      delete data.overdue;
    }

    if (!this.approved) {
      delete data.approved;
    }

    if (!this.overdue_notification_not_sent) {
      delete data.overdue_notification_not_sent;
    }

    if (!this.unpaid_notification_not_sent) {
      delete data.unpaid_notification_not_sent;
    }

    if (!this.export_id_min) {
      delete data.export_id_min;
    }

    if (!this.export_id_max) {
      delete data.export_id_max;
    }

    if (!this.is_not_exported) {
      delete data.is_not_exported;
    }

    if (!this.is_previously_exported) {
      delete data.is_previously_exported;
    }

    if (!this.is_payments_not_exported) {
      delete data.is_payments_not_exported;
    }

    if (!this.is_payments_previously_exported) {
      delete data.is_payments_previously_exported;
    }


    if(!this.is_previously_exported && !this.is_payments_previously_exported) {
      delete data.export_id_min;
      delete data.export_id_max;
    }

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (this.salesDateRange.startDate) {
      data.sales_date_after = moment(this.salesDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.sales_date_before = moment(this.salesDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (this.paymentsDateRange.startDate) {
      data.payments_date_after = moment(this.paymentsDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.payments_date_before = moment(this.paymentsDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    if (!this.identity_verification) {
      delete data.identity_verification;
    }

    if (!this.kyc_status_verification) {
      delete data.kyc_status_verification;
    }

    if (!this.partially_paid) {
      delete data.partially_paid;
    }

    if (!this.exclude_from_auto_payments) {
      delete data.exclude_from_auto_payments;
    }

    if (!this.auto_payment_status) {
      delete data.auto_payment_status;
    }

    delete data.dateRange;
    delete data.salesDateRange;
    delete data.paymentsDateRange;

    data.status = data.status.join(',');
    data.branch_uuids = data.branch_uuids.join(',');
    data.source_of_sale = data.source_of_sale.join(',');

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(InvoiceSearch);
